import script from "./ReferencesDetailTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReferencesDetailTitle.vue?vue&type=script&lang=ts&setup=true"

import "./ReferencesDetailTitle.vue?vue&type=style&index=0&id=0cc6dd1b&lang=scss"

const __exports__ = script;

export default __exports__